import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import ThemeLogo from "./ThemeLogo";

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (email) => {
    // Simple email regex
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess('A password reset email has been sent. Please check your inbox.');
    } catch (err) {
      let userMessage = 'Failed to send reset email. Please try again.';
      if (err.code === 'auth/user-not-found') {
        userMessage = 'No account found with this email.';
      } else if (err.code === 'auth/invalid-email') {
        userMessage = 'Please enter a valid email address.';
      } else if (err.code === 'auth/network-request-failed') {
        userMessage = 'Network error. Please check your connection and try again.';
      }
      setError(userMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      width: '100vw',
      background: 'rgba(0,0,0,0.0)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 2000
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '32px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        padding: '48px 40px 32px 40px',
        maxWidth: 400,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
      }}>
        <span
          onClick={() => navigate('/login')}
          style={{
            position: 'absolute',
            top: 18,
            right: 24,
            fontSize: 22,
            color: '#888',
            cursor: 'pointer',
            zIndex: 10,
            fontWeight: 400,
            lineHeight: 1,
            transition: 'color 0.2s',
          }}
          aria-label="Close forgot password"
          title="Close"
        >
          &times;
        </span>
        <ThemeLogo style={{ width: 130, height: 130, marginBottom: 24 }} alt="Logo" />
        <h2 style={{ fontSize: '2.1rem', fontWeight: 700, margin: 0, color: '#111', alignSelf: 'flex-start' }}>Forgot Password</h2>
        <div style={{ width: '100%', margin: '8px 0 24px 0', alignSelf: 'flex-start' }}>
          <span style={{ color: '#222', fontSize: '1.08rem', fontWeight: 500 }}>Enter your email to reset your password.</span>
        </div>
        {error && (
          <div style={{ color: 'red', marginBottom: 12, textAlign: 'center', fontWeight: 600 }}>{error}</div>
        )}
        {success && (
          <div style={{ color: '#22d3ee', marginBottom: 12, textAlign: 'center', fontWeight: 600 }}>{success}</div>
        )}
        <form style={{ width: '100%' }} onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Enter your email"
            style={{
              width: '100%',
              padding: '16px',
              borderRadius: '10px',
              border: 'none',
              background: '#f3f3ff',
              color: '#222',
              fontSize: '1.08rem',
              marginBottom: 18,
              outline: 'none',
              fontWeight: 500,
              boxSizing: 'border-box',
            }}
            required
          />
          <button
            type="submit"
            style={{
              width: '100%',
              background: 'linear-gradient(135deg, #6d28d9 0%, #4f46e5 45%, #22d3ee 100%)',
              color: '#fff',
              fontWeight: 700,
              fontSize: '1.18rem',
              border: 'none',
              borderRadius: '12px',
              padding: '16px 0',
              margin: '10px 0 0 0',
              boxShadow: '0 4px 16px rgba(139, 92, 246, 0.25)',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              transition: 'all 0.3s ease',
            }}
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <div style={{ width: '100%', textAlign: 'center', marginTop: 28, color: '#888', fontSize: '1.05rem', fontWeight: 500 }}>
          <span style={{ cursor: 'pointer', color: '#22d3ee', transition: 'color 0.2s' }} 
                onMouseEnter={(e) => e.target.style.color = '#67e8f9'} 
                onMouseLeave={(e) => e.target.style.color = '#22d3ee'}
                onClick={() => navigate('/login')}>Back to Login</span>
        </div>
      </div>
    </div>
  );
} 